module.exports = __webpack_public_path__ + "static/media/Polygon-5.6402f8a5.svg";